<template>
    <v-container :fluid="true" class="max-height">
        <v-row>
            <v-col class="px-5 d-flex justify-space-between" cols="12">
                <h1 class="text-left">Fleet Models</h1>
                <v-btn v-if="isStaff" color="black" prepend-icon="mdi-plus" @click="createRecord">Add</v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-table>
                    <thead>
                    <tr>
                        <th></th>
                        <th>Manufacturer</th>
                        <th>Asset Type</th>
                        <th>Name</th>
                        <th>Wmi Prefix</th>
                        <th>Fuel Tank Size</th>
                        <th>Fuel Tank Unit</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="record in records" v-if="records.length" class="text-left">
                        <td>
                            <v-avatar :image="record.image" rounded="sm" size="28"/>
                        </td>
                        <td>{{ record.manufacturer }}</td>
                        <td>{{ record.asset_type }}</td>
                        <td>{{ record.name }}</td>
                        <td>{{ record.wmi_prefix }}</td>
                        <td>{{ record.fuel_tank_size }}</td>
                        <td class="text-capitalize">{{ record.fuel_tank_unit }}</td>
                        <td>
                            <v-btn-group density="compact" divided variant="outlined">
                                <template v-if="user.type === 'admin'">
                                    <v-btn v-if="user.type === 'admin'" :disabled="dialogSwitch"
                                           class="text-black" size="x-small" @click="vehicleServiceTypes(record,1)">
                                        Inspection
                                        Types
                                    </v-btn>
                                    <v-btn v-if="user.type === 'admin'" :disabled="dialogSwitch"
                                           class="text-black" size="x-small" @click="vehicleServiceTypes(record)">
                                        Maintenance Service Types
                                    </v-btn>
                                </template>
                                <v-btn v-if="isStaff" class="text-warning" prepend-icon="mdi-pencil"
                                       size="x-small" @click="editRecord(record)">Edit
                                </v-btn>
                                <v-btn v-if="isStaff" class="text-error" prepend-icon="mdi-delete" size="x-small"
                                       @click="deleteRecord(record)">Delete
                                </v-btn>
                            </v-btn-group>
                        </td>
                    </tr>
                    <tr v-else>
                        <td v-if="loading" class="text-center" colspan="11">
                            <v-progress-circular color="primary" indeterminate/>
                        </td>
                        <td v-else class="text-center" colspan="11">No record found</td>
                    </tr>
                    </tbody>
                </v-table>
            </v-col>
        </v-row>

        <v-row v-if="totalPages > 1" justify="center">
            <v-col cols="8">
                <v-container class="max-width">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        class="my-4"
                        density="compact"
                        @update:model-value="fetchRecords"
                    ></v-pagination>
                </v-container>
            </v-col>
        </v-row>
    </v-container>

    <Creat_Edit v-if="dialogSwitch"
                v-model="dialogSwitch"
                :record="selectedRecord"
                @addRecord="addRecord"
                @updateRecord="updateRecord"/>


    <VehicleServiceTypes v-if="serviceTypesDialogSwitch"
                         v-model="serviceTypesDialogSwitch"
                         :type="selectedType"
                         :vehicle-model="selectedRecord"/>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {send} from "@/composables/apiClient";
import {useAuthStore} from "@/stores/authStore";
import {useSnackbarStore} from "@/stores/snackBarStore";
import Creat_Edit from "@/components/dialogs/fleet/Model_Create_Edit.vue";
import VehicleServiceTypes from "@/components/dialogs/fleet/VehicleServiceTypesList.vue";

const {user} = useAuthStore();
const isStaff = user?.type === 'admin' || !!user?.super;
const loading = ref(true);
const totalPages = ref(1);
const currentPage = ref(1);
const records = ref([]);
const dialogSwitch = ref(false);
const selectedType = ref(null);
const selectedRecord = ref(null);
const serviceTypesDialogSwitch = ref(false);
const {showSnackbar} = useSnackbarStore();

onMounted(() => {
    fetchRecords();
});

const vehicleServiceTypes = (model, type = 0) => {
    selectedRecord.value = model;
    selectedType.value = type;
    serviceTypesDialogSwitch.value = true;
}

const fetchRecords = () => {
    send('get', `fleet/models`)
        .then((response) => {
            records.value = response.data.data.data ?? [];
            totalPages.value = response.data.data.last_page;
            currentPage.value = response.data.data.current_page;
        })
        .catch((error) => {
            console.log(error)
            showSnackbar('Models could not be loaded', 'error')
        }).finally(() => loading.value = false)
}
const addRecord = (record) => {
    records.value.unshift(record);
}
const createRecord = () => {
    selectedRecord.value = null;
    dialogSwitch.value = true;
}
const editRecord = (record) => {
    selectedRecord.value = record;
    dialogSwitch.value = true;
}
const updateRecord = (record) => {
    records.value.map((comp, index) => {
        if (comp.id === record.id) {
            records.value[index] = record;
        }
    });
    selectedRecord.value = null;
}
const deleteRecord = (record) => {
    if (confirm(`Are you sure to delete "${record.name}" record?`)) {
        send('delete', `fleet/models/${record.id}`)
            .then((response) => {
                if (response.data.success) {
                    records.value.map((item, index) => {
                        if (item.id === record.id) {
                            records.value.splice(index, 1);
                        }
                    });
                    showSnackbar(response.data.message);
                }
            })
            .catch((error) => {
                if (error.response.data.message) {
                    showSnackbar(error.response.data.message, 'error')
                } else {
                    showSnackbar(`"${record.name}" manufacturer could not be deleted`, 'error')
                }
            })
    }
}
</script>
